export default __webpack_public_path__ + "f07901ca3513801ba34450b380a77053.png";